import { render, staticRenderFns } from "./CredentialsWithAsyncFallback.vue?vue&type=template&id=644e6846&scoped=true"
import script from "./CredentialsWithAsyncFallback.vue?vue&type=script&lang=js"
export * from "./CredentialsWithAsyncFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e6846",
  null
  
)

export default component.exports